/* eslint-disable no-use-before-define */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-tabs */
/* eslint-disable max-len */
/* eslint-disable no-new-object */
/* eslint-disable no-plusplus */
import '../../../assets/css/pages/honor-list.css';
import '../../../assets/css/pages/product.css';
import api from '../../utils/api';
import {
  isInput, checkRequired, Mobile, validationArr, setValidationArr,
} from '../../utils/common';

const recordName = document.getElementById('name');
const recordBirth = document.getElementById('birth');
const course = document.getElementById('course');
const age = document.getElementById('age');
const indTab = document.getElementById('ind_tab');
const recordTab = document.getElementById('record_tab');
const recordConfirm = document.getElementById('record_confirm');
const recordPartConfirm = document.getElementById('record_part_confirm');

let timeString = '';
let pageCount = 0;
let pagingNext = null;
let pagingPrev = null;
let totalData;
let globalCurrentPage = '1';
let recordIndObj = new Object();
let recordIndPartObj = new Object();

let partAge = 'all';

function changeMedalimg(value) {
  const medalImg = document.getElementById('medal_img_id');
  const medalText = document.getElementById('medal_text_id');

  const medalImages = {
    2013: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2013.png',
    2014: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2014.png',
    2015: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2015.png',
    2016: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2016.png',
    2017: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2017.png',
    2018: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2018.png',
    2019: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2019.png',
    2022: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2022.png',
    2023: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2023.png',
    2024: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2024.png',
    2025: 'https://image.chosun.com/chuncheonmarathon/2023/medal_2025.png',
  };

  if (value > 1994 && value < 2013) {
    medalImg.src = 'https://image.chosun.com/chuncheonmarathon/2023/past_medal.png';
    medalText.innerText = value;
  } else if (medalImages[value]) {
    medalImg.src = medalImages[value];
  } else {
    medalImg.src = '';
    medalText.innerText = '';
  }
}

// 시간 데이터 통일
function timeConvert(value) {
  if (value !== '') {
    let recordTimeSplit = '';
    let hours = '';
    let minutes = '';
    let seconds = '';

    const recordTimeCut = value.substring(0, 8);
    recordTimeSplit = recordTimeCut.split(':');

    if (recordTimeSplit[0].length === 1) {
      hours = `0${recordTimeSplit[0]}`;
    } else {
      hours = recordTimeSplit[0];
    }
    minutes = recordTimeSplit[1];
    seconds = recordTimeSplit[2];

    timeString = `${hours}:${minutes}:${seconds}`;
  } else {
    timeString = '00:00:00';
  }

  return timeString;
}

// 버튼 클릭시 데이터 표출
function recordDetail() {
  const objectData = recordIndObj.data;

  document.getElementById('medal_text_id').innerText = '';
  changeMedalimg(Number(objectData.year), objectData);

  document.getElementById('record_name').innerText = document.getElementById('name').value;
  document.getElementById('record_gender').innerText = objectData.gender === 'M' ? '남성' : '여성';
  document.getElementById('record_number').innerText = objectData.baebun;
  if (objectData.code === '1') {
    document.getElementById('record_course').innerText = '42.195km';
  } else if (objectData.code === '2') {
    document.getElementById('record_course').innerText = '10km';
  } else if (objectData.code === '4') {
    document.getElementById('record_course').innerText = 'Half';
  }

  document.getElementById('record_netfull').innerText = timeConvert(objectData.netFull);
  document.getElementById('record_nettime').innerText = timeConvert(objectData.netFull);
  document.getElementById('record_guntime').innerText = timeConvert(objectData.gunFull);
  document.getElementById('record_pace').innerText = objectData.recPace !== '' ? objectData.recPace : '-';
  document.getElementById('record_rank').innerText = objectData.rankTotal;
  document.getElementById('record_agerank').innerText = objectData.rankAge !== '' ? objectData.rankAge : '-';

  if (objectData.code === '2') {
    document.getElementById('record_area_form').style.display = 'none';
  } else {
    document.getElementById('record_5').innerText = timeConvert(objectData.rec5km);
    document.getElementById('record_10').innerText = timeConvert(objectData.rec10km);
    document.getElementById('record_15').innerText = timeConvert(objectData.rec15km);
    document.getElementById('record_20').innerText = timeConvert(objectData.rec20km);
    document.getElementById('record_half').innerText = timeConvert(objectData.recHalf);
    document.getElementById('record_25').innerText = timeConvert(objectData.rec25km);
    document.getElementById('record_30').innerText = timeConvert(objectData.rec30km);
    document.getElementById('record_35').innerText = timeConvert(objectData.rec35km);
    document.getElementById('record_40').innerText = timeConvert(objectData.rec40km);
  }
}

// 기록별 조회 버튼 api 호출
async function SearchByRecord(number, ages) {
  const selectedGender = document.querySelector('input[type="radio"][name="gender"]:checked')?.value;
  const res = await api.partIndRecord(document.getElementById('course').value, selectedGender, ages, number);

  if (res) {
    recordIndPartObj = res;
  }

  if (recordIndPartObj && recordIndPartObj.data.recordDtoList.length > 0) {
    document.querySelector('.check_form').style.display = 'none';
    document.querySelector('.result_part_form').style.display = 'block';
    document.getElementById('pagingul').style.display = 'flex';

    if (document.getElementById('course').value === '1') {
      document.getElementById('result_course').innerText = '42.195km';
    } else if (document.getElementById('course').value === '4') {
      document.getElementById('result_course').innerText = 'Half';
    } else if (document.getElementById('course').value === '2') {
      document.getElementById('result_course').innerText = '10km';
    }

    document.getElementById('result_gender').innerText = selectedGender === 'M' ? '남성' : '여성';

    const renderTarget = document.getElementById('record_table');
    renderTarget.innerHTML = '';

    recordIndPartObj.data.recordDtoList.forEach((ele, i) => {
      const recordNumber = globalCurrentPage !== '1' ? (globalCurrentPage - 1) * 20 + i + 1 : ((globalCurrentPage - 1) * 10) + (i + 1);
      const recordTime = ele.netFull;
      const recordAge = ele.age;

      renderTarget.innerHTML += `
						<tr id="tr_${i}">
								<td>${recordNumber}</td>
								<td>${recordTime}</td>
								<td>${recordAge}</td>
						</tr>
						`;
    });

    totalData = recordIndPartObj.data.totalCnt;
  } else if (recordIndPartObj !== undefined && recordIndPartObj.data.recordDtoList.length === 0) {
    alert('조회 결과가 없습니다.');

    for (let j = 0; j < 20; j++) {
      const el = document.getElementById(`tr_${j}`);
      if (el) el.remove();
    }
    document.getElementById('age').value = 'all';
    partAge = 'all';
    recordIndPartObj = new Object();
    paging(1);
    document.getElementById('1').classList.add('active');
  } else {
    for (let j = 0; j < 20; j++) {
      const el = document.getElementById(`tr_${j}`);
      if (el) el.remove();
    }
    document.getElementById('age').value = 'all';
    partAge = 'all';
    recordIndPartObj = new Object();
    paging(1);
    document.getElementById('1').classList.add('active');
  }
}

async function paging(currentPage) {
  if (!recordIndPartObj.data) {
    await SearchByRecord(0, partAge);
  }

  if (Mobile()) {
    pageCount = 5;
  } else {
    pageCount = 10;
  }

  const totalPage = Math.ceil(totalData / 20);

  if (totalPage < pageCount) {
    pageCount = totalPage;
  }

  const pageGroup = Math.ceil(currentPage / pageCount);
  let last = pageGroup * pageCount;

  if (last > totalPage) {
    last = totalPage;
  }

  const first = last - (pageCount - 1);
  const next = last + 1;
  const prev = first - 1;

  pagingNext = next;
  pagingPrev = prev;

  let pageHtml = '';

  pageHtml += "<button class='pagination-button' type='button' id='prev-button'></button>";

  for (let i = first; i <= last; i++) {
    if (currentPage === i) {
      pageHtml += `<button class='pagination-number' type='button' id='${i}'>${i}</button>`;
    } else {
      pageHtml += `<button class='pagination-number' type='button' id='${i}'>${i}</button>`;
    }
  }

  pageHtml += "<button class='pagination-button' type='button' id='next-button'></button>";

  document.getElementById('pagingul').innerHTML = pageHtml;

  if (prev > 0) {
    document.getElementById('prev-button').disabled = false;
  } else {
    document.getElementById('prev-button').disabled = true;
  }

  if (last < totalPage) {
    document.getElementById('next-button').disabled = false;
  } else {
    document.getElementById('next-button').disabled = true;
  }
}

const tournamentFn = {
  maxLengthCheck(object) {
    if (object.value.length > object.maxLength) {
      // eslint-disable-next-line no-param-reassign
      object.value = object.value.slice(0, object.maxLength);
    }
  },

  recordPrev() {
    // eslint-disable-next-line no-restricted-globals
    location.href = '../record/tournament.html';
  },
};

window.tournamentFn = tournamentFn;

export default tournamentFn;

document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.ind_check_form').style.display = 'block';
  document.querySelector('.part_check_form').style.display = 'none';
  document.querySelector('.result_ind_form').style.display = 'none';
  document.querySelector('.result_part_form').style.display = 'none';

  recordName.addEventListener('change', () => {
    isInput('local', recordName);
  });

  recordBirth.addEventListener('change', () => {
    isInput('local', recordBirth);
  });

  course.addEventListener('change', () => {
    isInput('local', course);
  });

  age.addEventListener('change', async () => {
    await SearchByRecord(0, age.value);
  });

  indTab.addEventListener('click', () => {
    document.querySelector('.ind_check_form').style.display = 'block';
    document.querySelector('.part_check_form').style.display = 'none';

    document.getElementById('ind_tab').style.color = '#fff';
    document.getElementById('record_tab').style.color = '#000';
    document.getElementById('ind_tab').style.backgroundColor = '#000';
    document.getElementById('record_tab').style.backgroundColor = '#fff';
  });

  recordTab.addEventListener('click', () => {
    document.querySelector('.ind_check_form').style.display = 'none';
    document.querySelector('.part_check_form').style.display = 'block';

    document.getElementById('record_tab').style.color = '#fff';
    document.getElementById('ind_tab').style.color = '#000';
    document.getElementById('record_tab').style.backgroundColor = '#000';
    document.getElementById('ind_tab').style.backgroundColor = '#fff';
  });

  recordConfirm.addEventListener('click', async () => {
    checkRequired('local', [recordName, recordBirth]);

    if (validationArr.length > 0) {
      document.getElementById(validationArr[0]).focus();
    } else {
      setValidationArr();

      const res = await api.indRecord(document.getElementById('name').value, document.getElementById('birth').value);

      recordIndObj = res;

      if (recordIndObj.data !== undefined) {
        document.querySelector('.check_form').style.display = 'none';
        document.querySelector('.result_ind_form').style.display = 'block';

        recordDetail();
      }
    }
  });

  recordPartConfirm.addEventListener('click', async () => {
    checkRequired('local', [course]);

    if (validationArr.length > 0) {
      document.getElementById(validationArr[0]).focus();
    } else {
      setValidationArr();

      await paging(1);

      document.getElementById('1').classList.add('active');
    }
  });

  document.getElementById('pagingul').addEventListener('click', async (e) => {
    if (e.target.tagName.toLowerCase() === 'button') {
      let selectedPage = e.target.textContent;
      const id = e.target.id;

      if (id === 'next-button') selectedPage = pagingNext;
      if (id === 'prev-button') selectedPage = pagingPrev;

      globalCurrentPage = selectedPage;

      await paging(selectedPage);

      await SearchByRecord(selectedPage - 1, age.value);

      // active 클래스 처리
      const allPageButtons = document.querySelectorAll('.pagination-number');
      allPageButtons.forEach((btn) => btn.classList.remove('active'));
      const selectedBtn = document.getElementById(selectedPage);
      if (selectedBtn) selectedBtn.classList.add('active');
    }
  });
});
